import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { select, Store } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { TranslateService } from '@ngx-translate/core';
import {
  FacilitiesService,
  FacilityModel,
  selectFacilitiesActionLoading,
  SharedHttpRequestService,
  NoteEntityType,
} from 'src/app/core/lists';
import { AuthService, currentUser, currentUserPermissions } from 'src/app/core/auth';
import { LayoutUtilsService, MessageType, TypesUtilsService } from 'src/app/core/_base/crud';
import { AppState } from 'src/app/core/reducers';
import { selectFacilityErrorState } from 'src/app/core/lists/_selectors/facility.selectors';
import { FacilityOnServerUpdated } from 'src/app/core/lists/_actions/facility.actions';
import { DatePipe } from '@angular/common';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import {
  MAT_MOMENT_DATE_ADAPTER_OPTIONS,
  MomentDateAdapter,
} from '@angular/material-moment-adapter';
import { tagsViewContext } from '../../../../../../core/lists/_services/shared-http-request.service';
import { GeneralValidationMessagesService } from '../../../../../../core/services/general-validation-messages.service';
import OpenLocationCode from 'open-location-code-typescript';
import { MapsAPILoader } from '@agm/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { GlobalSettingsService } from 'src/app/core/services/global-settings.service';
import { ZoomInEntityComponent } from '../../../../../partials/content/general/zoom-in-entity/zoom-in-entity.component';
import { NavigationService } from '../../../../../../core/services/navigation.service';
import { PictureCropperComponent } from '../../../../../partials/content/general/picture-cropper/picture-cropper.component';
import { ImageSettingService } from '../../../../../../core/services/image-setting.service';

export const MY_FORMATS = {
  parse: {
    dateInput: 'MM-DD-YY',
  },
  display: {
    dateInput: 'MM-DD-YY',
    monthYearLabel: 'MMM, YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'kt-facility-edit',
  templateUrl: './facility-edit.component.html',
  providers: [
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  styleUrls: ['facility-edit.component.scss'],
})
export class FacilityEditComponent implements OnInit, OnDestroy {
  // for HTML template use
  NoteEntityType = NoteEntityType;
  //
  facility: FacilityModel;
  geocoder;
  oldFacility: FacilityModel;
  facilityForm: FormGroup;
  hasFormErrors = false;
  hasSubmissionErrors = false;
  submissionErrorObj: any;
  private subscriptions: any[] = [];
  tags = new FormControl();
  tags$ = new BehaviorSubject<any>([]);
  isViewMode: boolean;
  urbanizationValue;
  Address1Value;
  Address2Value;
  cityValue;
  zipValue;
  params: any;
  @Input() entity_id;
  @Input() fromCanvas;
  @Output() focusedViewOpen = new EventEmitter<any>();
  @Output() navigateToContact = new EventEmitter<any>();
  lat = null;
  lng = null;
  facilityProfile;
  newAvatar = null;
  needToChangeImage = false;
  basicInfo: any = {};
  needToChange = false;
  facilityDefault = '/assets/media/facilities/defaultFacility.svg';
  view = false;
  tabs = [
    { index: 0, label: 'General Info', icon: 'mat-tab-label-icon fa fa-info', active: true },
    {
      index: 1,
      label: 'Relations',
      icon: 'mat-tab-label-icon fas fa-people-arrows',
      active: false,
      permission: 'canViewRelation',
    },
    {
      index: 2,
      label: 'Notes',
      icon: 'flaticon-notes icon-md',
      active: false,
      permission: 'canViewNote',
    },
    {
      index: 3,
      label: 'Residents',
      icon: 'mat-tab-label-icon fas far fa-building',
      active: false,
      permission: 'canViewPatient',
    },
    {
      index: 4,
      label: 'Other Details',
      icon: 'mat-tab-label-icon fas fa-ellipsis-h',
      active: false,
    },
    {
      index: 5,
      label: 'Sales Teams',
      icon: 'mat-tab-label-icon icon-lg fas flaticon-network',
      active: false,
      permission: 'accessToSalesTeamsModule',
    },
    {
      index: 6,
      label: 'Documents',
      icon: 'mat-tab-label-icon icon-lg fa fa-file-alt',
      active: false,
    },
    {
      index: 7,
      label: 'Affiliations',
      icon: 'mat-tab-label-icon icon-lg fa fa-handshake',
      active: false,
    },
  ];
  loadingData = false;
  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private facilityFB: FormBuilder,
    private auth: AuthService,
    private facilityService: FacilitiesService,
    private translate: TranslateService,
    private layoutUtilsService: LayoutUtilsService,
    private store: Store<AppState>,
    private cdr: ChangeDetectorRef,
    public datepipe: DatePipe,
    private sharedHttpRequestService: SharedHttpRequestService,
    private globalService: GeneralValidationMessagesService,
    private mapsAPILoader: MapsAPILoader,
    private dialog: MatDialog,
    private globalSettings: GlobalSettingsService,
    private typesUtilsService: TypesUtilsService,
    private navigationService: NavigationService,
    private imageSettingService: ImageSettingService,
  ) {
    this.mapsAPILoader.load().then(() => {
      this.geocoder = new google.maps.Geocoder();
    });
  }
  closeDialog(e) {
    if (e) {
      this.focusedViewOpen.emit(true);
      this.navigateToContact.emit(true);
    }
  }
  ngOnInit() {
    if (this.entity_id) {
      this.globalService.getEntitiesById('facilities', this.entity_id).subscribe((result) => {
        if (result) {
          this.loadFacility(result.data);
          this.cdr.detectChanges();
        }
      });
      return;
    }

    // this line due to make the navigation service return to facility list if there is no ->
    // navigation stack saved before in special cases
    this.navigationService.setDefaultRoot('/lists/facilities');

    this.activatedRoute.queryParams.subscribe((params) => {
      params.tab_index ? this.changeTab(+params.tab_index) : this.changeTab(0);
    });
    const userSub = this.store.pipe(select(currentUser)).subscribe((res) => {
      if (!res) {
        this.goBack();
      }
    });
    this.subscriptions.push({ id: 1, sub: userSub });
    const routeSubscription = this.activatedRoute.params.subscribe((params) => {
      const id = params.id;
      if (id && id > 0) {
        const facilityById = this.globalService
          .getEntitiesById('facilities', id)
          .subscribe((result) => {
            if (result) {
              this.loadFacility(result.data);
              this.cdr.detectChanges();
              return;
            }
          });
        this.subscriptions.push({ sub: facilityById });
      } else {
        this.facility = new FacilityModel();
        this.facility.clear();

        this.oldFacility = Object.assign({}, this.facility);
        this.initFacility();
      }
    });
    this.subscriptions.push({ id: 3, sub: routeSubscription });
  }

  loadFacility(res) {
    this.facility = res;
    this.loadTags();
    this.oldFacility = Object.assign({}, this.facility);
    this.initFacility();
  }

  ngOnDestroy() {
    this.cdr.detach();
    this.subscriptions.forEach((el) => {
      if (el.sub) {
        el.sub.unsubscribe();
      }
    });
  }

  initFacility() {
    this.createForm();
    if (!this.facility.id) {
      this.isViewMode = false;
    } else if (
      this.activatedRoute.url[`_value`][1] &&
      this.activatedRoute.url[`_value`][1].path === 'view'
    ) {
      this.isViewMode = true;
      this.facilityForm.disable();
      this.facilityForm.controls.geolocation_address.enable();
    } else {
      this.subscriptions.push(
        this.store.pipe(select(currentUserPermissions)).subscribe((res) => {
          if (!res.some((p) => p.name === 'canEditFacility')) {
            this.facilityForm.disable();
            this.facilityForm.controls.geolocation_address.enable();
          }
        }),
      );
      this.isViewMode = false;
    }
    this.basicInfo = {
      avatar: this.facility.pre_signed_url?.url
        ? this.facility.pre_signed_url.url
        : this.facilityDefault,
    };
    this.facilityProfile = this.basicInfo.avatar ? this.basicInfo.avatar : this.facilityDefault;
  }

  createForm() {
    this.facilityForm = this.facilityFB.group({
      id: [this.facility.id],
      name: [this.facility.name, Validators.required],
      email: [this.facility.email, Validators.compose([Validators.email])],
      city: [
        this.facility.city,
        Validators.compose([Validators.required, Validators.maxLength(30)]),
      ],
      state: [this.facility.state, Validators.required],
      address_1: [
        this.facility.address_1,
        Validators.compose([Validators.required, Validators.maxLength(48)]),
      ],
      address_2: [this.facility.address_2, Validators.maxLength(48)],
      is_active: [this.facility.is_active, Validators.required],
      zip: [
        this.facility.zip,
        Validators.compose([Validators.required, Validators.pattern(/(^\d{5}$)|(^\d{5}-\d{4}$)/)]),
      ],
      phone: [
        this.facility.phone && this.facility.phone.length > 0
          ? '(' +
            this.facility.phone.substring(0, 3) +
            ') ' +
            this.facility.phone.substring(3, 6) +
            '-' +
            this.facility.phone.substring(6, 10)
          : '',
        Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/),
      ],
      facility_type: [this.facility.facility_type],
      fax: [
        this.facility.fax && this.facility.fax.length > 0
          ? '(' +
            this.facility.fax.substring(0, 3) +
            ') ' +
            this.facility.fax.substring(3, 6) +
            '-' +
            this.facility.fax.substring(6, 10)
          : '',
        Validators.pattern(/^\(([0-9]{3})\)[ ]([0-9]{3})[-]([0-9]{4})$/),
      ],
      facility_id: [this.facility.facility_id],
      days_supply: [this.facility.days_supply],
      npi: [this.facility.npi],
      filled_by_robot: [this.facility.filled_by_robot],
      note: [this.facility.note],
      facility_code: [this.facility.facility_code],
      cycle_fill: [this.facility.cycle_fill],
      lead_days: [this.facility.lead_days],
      filled_up_to: [this.facility.filled_up_to],
      lead_days_to_bill: [this.facility.lead_days_to_bill],
      lead_days_to_delivery: [this.facility.lead_days_to_delivery],
      location_id: [this.facility.location_id],
      processed: [this.facility.processed],
      packing_id: [this.facility.packing_id],
      last_modified_user: [this.facility.last_modified_user],
      urbanization: [this.facility.urbanization, Validators.maxLength(48)],
      latitude: [{ value: this.facility.latitude ? this.facility.latitude : null, disabled: true }],
      longitude: [
        { value: this.facility.longitude ? this.facility.longitude : null, disabled: true },
      ],
      plus_code: [{ value: this.facility.plus_code, disabled: true }],
      geolocation_address: [this.facility.geolocation_address],
      office_number: [this.facility.office_number],
      extension: [this.facility.extension],
    });
    this.urbanizationValue = this.facility.urbanization;
    this.Address1Value = this.facility.address_1;
    this.Address2Value = this.facility.address_2;
    this.cityValue = this.facility.city;
    this.zipValue = this.facility.zip;
    if (
      (!this.facility?.latitude || !this.facility?.longitude) &&
      !this.facility.geolocation_address &&
      this.facility?.plus_code
    ) {
      const area = OpenLocationCode.decode(this.facilityForm.get('plus_code').value);
      this.setCoordinates(area.latitudeCenter, area.longitudeCenter);
      setTimeout(() => {
        this.setGeolocationAddress(area.latitudeCenter, area.longitudeCenter);
      }, 2500);
    }
    if (
      this.facility?.latitude &&
      this.facility?.longitude &&
      !this.facility?.plus_code &&
      !this.facility?.geolocation_address
    ) {
      this.setCoordinates(this.facility.latitude, this.facility.longitude);
      this.setGeolocationAddress(this.facility.latitude, this.facility.longitude);
      setTimeout(() => {
        this.setGeolocationAddress(this.facility.latitude, this.facility.longitude);
      }, 2500);
      this.facilityForm
        .get('plus_code')
        .setValue(OpenLocationCode.encode(this.facility.latitude, this.facility.longitude));
    }
    this.loadingData = true;
  }

  markerDragEnd($event: any) {
    this.setCoordinates($event.latLng.lat(), $event.latLng.lng());
    this.setGeolocationAddress(this.lat, this.lng);
  }

  setCoordinates(lat, lng) {
    this.facilityForm.get('latitude').setValue(lat);
    this.facilityForm.get('longitude').setValue(lng);
    this.lng = lng;
    this.lat = lat;
    this.cdr.detectChanges();
  }

  setGeolocationAddress(lat, lng) {
    const latLng = {
      lat: parseFloat(lat),
      lng: parseFloat(lng),
    };
    this.geocoder?.geocode({ location: latLng }, (response: any) => {
      if (response && response[0]) {
        this.facilityForm
          .get('geolocation_address')
          .setValue(response && response[0]?.formatted_address);
      } else {
        window.alert('No results found');
      }
    });
  }
  resetGeolocation() {
    this.facilityForm.get('geolocation_address').setValue(null);
    this.facilityForm.get('plus_code').setValue(null);
    this.facilityForm.get('latitude').setValue(null);
    this.facilityForm.get('longitude').setValue(null);
  }
  searchForGeolocation() {
    this.globalSettings
      .getPlusCode(this.facilityForm.get('geolocation_address').value)
      .subscribe((res) => {
        if (res.status === 'OK' || res.status === 'ok') {
          this.facility.geolocation_address = this.facilityForm.get('geolocation_address').value;
          this.facility.plus_code = res?.plus_code?.global_code;
          this.facility.latitude = res?.plus_code?.geometry?.location?.lat;
          this.facility.longitude = res?.plus_code?.geometry?.location?.lng;
          this.facilityForm.get('plus_code').setValue(res?.plus_code?.global_code);
          this.facilityForm.get('latitude').setValue(res?.plus_code?.geometry?.location?.lat);
          this.facilityForm.get('longitude').setValue(res?.plus_code?.geometry?.location?.lng);
          return;
        }
        const message = 'We could not find: ' + this.facilityForm.get('geolocation_address').value;
        this.layoutUtilsService.showActionNotification(
          message,
          MessageType.Read,
          3000,
          true,
          false,
        );
      });
  }

  goBack() {
    if (this.entity_id) return;
    this.navigationService.goBack();
  }

  reset() {
    const _title = this.translate.instant('DIALOG.RESET');
    const _description = this.translate.instant('DIALOG.ARE_YOU_SURE');
    const _waitDesciption = this.translate.instant('DIALOG.RESETING');

    const dialogRef = this.layoutUtilsService.confirmAction(_title, _description, _waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      }
      this.facility = Object.assign({}, this.oldFacility);
      this.createForm();
      this.hasFormErrors = false;
      this.facilityForm.markAsPristine();
      this.facilityForm.markAsUntouched();
      this.facilityForm.updateValueAndValidity();
    });
  }

  submit() {
    const controls = this.facilityForm.controls;
    /** check form */
    if (this.facilityForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      this.hasFormErrors = true;
      this.changeTab(0);
      return;
    }

    const editedFacility = this.prepareFacility();
    if (editedFacility.id > 0) {
      this.updateFacility(editedFacility);
      return;
    }
    this.addFacility(editedFacility);
  }

  prepareFacility(): FacilityModel {
    const controls = this.facilityForm.controls;
    const _facility = new FacilityModel();
    _facility.clear();
    _facility.id = this.facility.id;
    _facility.address_1 = controls.address_1.value;
    _facility.address_2 = controls.address_2.value;
    _facility.npi = controls.npi.value;
    _facility.name = controls.name.value;
    _facility.email = controls.email.value;
    _facility.phone =
      controls.phone.value !== null
        ? controls.phone.value.replace(/\D/g, '')
        : controls.phone.value;
    _facility.zip = controls.zip.value;
    _facility.facility_type = controls.facility_type.value;
    _facility.facility_id = controls.facility_id.value;
    _facility.is_active = controls.is_active.value;
    _facility.fax =
      controls.fax.value !== null ? controls.fax.value.replace(/\D/g, '') : controls.fax.value;
    _facility.geolocation_address = controls.geolocation_address.value;
    _facility.city = controls.city.value;
    _facility.state = controls.state.value ? controls.state.value.toUpperCase() : '';
    _facility.note = controls.note.value;
    _facility.lead_days = controls.lead_days.value;
    _facility.cycle_fill = controls.cycle_fill.value;
    _facility.lead_days_to_bill = controls.lead_days_to_bill.value;
    _facility.lead_days_to_delivery = controls.lead_days_to_delivery.value;
    _facility.location_id = controls.location_id.value;
    _facility.processed = controls.processed.value;
    _facility.facility_code = controls.facility_code.value;
    _facility.filled_up_to =
      controls.filled_up_to.value != null
        ? this.datepipe.transform(
            new Date(controls.filled_up_to.value),
            'yyyy-MM-dd hh:mm:ss',
            'utc',
          )
        : null;
    _facility.filled_by_robot = controls.filled_by_robot.value;
    _facility.packing_id = controls.packing_id.value;
    _facility.location_id = controls.location_id.value;
    _facility.tags = this.tags.value;
    _facility.urbanization = controls.urbanization.value;
    _facility.plus_code = controls.plus_code.value ? controls.plus_code.value : null;
    _facility.latitude = controls.latitude.value;
    _facility.longitude = controls.longitude.value;
    _facility.extension = controls.extension.value;
    _facility.office_number =
      controls.office_number.value != null
        ? controls.office_number.value.replace(/\D/g, '')
        : controls.office_number.value;
    if (this.needToChangeImage || this.needToChange) {
      _facility.avatar = this.basicInfo.avatarUUID;
    } else {
      _facility.avatar = this.facility.avatar;
    }
    for (const [key, value] of Object.entries(_facility)) {
      if (typeof value === 'string') {
        _facility[key] = value.trim();
      }
    }
    return _facility;
  }

  addFacility(_facility: FacilityModel) {
    this.facilityService.createFacility(_facility).subscribe(
      (facility: any) => {
        if (this.router.routerState.snapshot.url !== '/lists/facilities') {
          const message = this.translate.instant('FACILITY.ADDED');
          this.layoutUtilsService.showActionNotification(
            message,
            MessageType.Update,
            5000,
            false,
            false,
          );
          this.goBack();
        }
        this.facility = facility.data;
        this.updateFacilityImage(() => {
          const editedFacility = this.prepareFacility();
          if (editedFacility.id > 0) {
            this.updateFacility(editedFacility);
            return;
          }
          return null;
        });
      },
      (error) => {
        if (error?.error?.errors) {
          this.submissionErrorObj = error.error.errors;
        } else {
          this.submissionErrorObj = [{ message: 'GLOBAL.UNSPECIFIED_ERROR' }];
        }
        this.hasSubmissionErrors = true;
      },
    );
  }

  updateFacility(_facility: FacilityModel) {
    const updatedFacility: Update<FacilityModel> = {
      id: _facility.id,
      changes: _facility,
    };
    this.store.dispatch(
      new FacilityOnServerUpdated({
        partialFacility: updatedFacility,
        facility: _facility,
      }),
    );
    if (this.subscriptions.find((sub) => sub.id === 6) === undefined) {
      const updateSubscription = this.store
        .pipe(select(selectFacilitiesActionLoading))
        .subscribe((res) => {
          if (res !== true) {
            this.store.pipe(select(selectFacilityErrorState)).subscribe((error) => {
              if (error) {
                if (error.error.errors) {
                  this.submissionErrorObj = error.error.errors;
                } else {
                  this.submissionErrorObj = [{ message: 'GLOBAL.UNSPECIFIED_ERROR' }];
                }
                this.hasSubmissionErrors = true;
              } else {
                let message = '';
                if (!this.needToChangeImage) {
                  message = this.translate.instant('FACILITY.UPDATED');
                  this.layoutUtilsService.showActionNotification(
                    message,
                    MessageType.Update,
                    5000,
                    false,
                    false,
                  );
                  this.goBack();
                } else {
                  this.globalService
                    .getEntitiesById('facilities', this.facility.id)
                    .subscribe((facility) => {
                      if (facility) {
                        this.needToChangeImage = false;
                        this.loadFacility(facility.data);
                        this.loadTags();
                        message = 'Facility picture changed successfully';
                        this.layoutUtilsService.showActionNotification(
                          message,
                          MessageType.Update,
                          3000,
                          false,
                          false,
                        );
                        this.cdr.detectChanges();
                        return;
                      }
                    });
                }
              }
            });
          }
          this.cdr.detectChanges();
        });
      this.subscriptions.push({ id: 6, sub: updateSubscription });
    }
  }

  onAlertClose() {
    this.hasFormErrors = false;
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.facilityForm.controls[controlName];
    if (!control) {
      return false;
    }

    return control.hasError(validationType) && (control.dirty || control.touched);
  }

  private loadTags() {
    this.sharedHttpRequestService
      .getTagsForView(this.facility.id, tagsViewContext.ENTITIES)
      .subscribe((tags) => {
        this.tags$.next(tags.data);
      });
  }

  getStatusString(): string {
    switch (this.facilityForm.get('is_active').value) {
      case true:
        return this.translate.instant('GLOBAL.ACTIVE');
      case false:
        return this.translate.instant('GLOBAL.INACTIVE');
    }
    return '';
  }

  getFullNameList(contacts) {
    let res = '';
    if (!contacts) {
      return res;
    } else {
      contacts.forEach((value) => {
        if (!value.is_prime) return res;
        if (value.contact && value.contact.first_name) {
          res = res + value.contact.first_name;
        }
        if (value.contact && value.contact.last_name) {
          res = res + ' ' + value.contact.last_name;
        }
        res = res + ', ';
      });
      return res.slice(0, -2);
    }
  }

  putDash(e) {
    let x = e;
    if (x.length === 6 && x.charAt(5) !== '-') {
      x = x.slice(0, 5) + '-' + x.charAt(x.length - 1);
    }
    return x;
  }

  updateProfile() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.closeOnNavigation = true;
    dialogConfig.width = '600px';
    dialogConfig.height = '400px';
    const defaultImage = this.facilityDefault;
    if (this.facility.id) {
      this.globalService.getEntitiesById('facilities', this.facility.id).subscribe((facility) => {
        if (facility?.data) {
          dialogConfig.data = {
            existImage: facility?.data?.pre_signed_url?.url,
            mode: 'UPDATE',
            defaultImage,
          };
          const dialogRef = this.dialog.open(PictureCropperComponent, dialogConfig);
          dialogRef.afterClosed().subscribe((result) => {
            if (result) {
              switch (result.mode) {
                case 'DELETE': {
                  this.needToChangeImage = true;
                  const editedFacility = this.prepareFacility();
                  editedFacility.avatar = null;
                  if (editedFacility.id > 0) {
                    this.updateFacility(editedFacility);
                    return;
                  }
                  break;
                }
                case 'UPDATE': {
                  if (result.img) {
                    this.newAvatar = this.imageSettingService.dataURLtoFile(result.img, 'fileName');
                    this.needToChangeImage = true;
                    const reader = new FileReader();
                    reader.readAsDataURL(this.newAvatar);
                    reader.onloadend = () => {
                      this.basicInfo.avatar = reader.result;
                      this.cdr.detectChanges();
                    };
                    let editedFacility = this.prepareFacility();
                    if (editedFacility.id > 0) {
                      this.updateFacilityImage(() => {
                        editedFacility = this.prepareFacility();
                        if (editedFacility.id > 0) {
                          this.updateFacility(editedFacility);
                          return;
                        }
                        return null;
                      });
                      return;
                    }
                  }
                  break;
                }
              }
            }
          });
        }
      });
    } else {
      dialogConfig.data = { existImage: null, mode: 'UPDATE', defaultImage };
      const dialogRef = this.dialog.open(PictureCropperComponent, dialogConfig);
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          switch (result.mode) {
            case 'UPDATE': {
              if (result.img) {
                this.newAvatar = this.imageSettingService.dataURLtoFile(result.img, 'fileName');
                this.facilityProfile = result.img;
                this.needToChangeImage = true;
                const reader = new FileReader();
                reader.readAsDataURL(this.newAvatar);
                reader.onloadend = () => {
                  this.basicInfo.avatar = reader.result;
                  this.cdr.detectChanges();
                };
              }
              break;
            }
          }
        }
      });
    }
  }

  private updateFacilityImage(cc) {
    if (this.needToChangeImage) {
      return this.facilityService
        .updateFacilityImage(this.newAvatar, this.facility.id)
        .subscribe((res2) => {
          this.facilityService.uploadFacilityImage(res2, this.newAvatar).subscribe(() => {
            this.basicInfo.avatarUUID = res2.data.uuid;
            cc();
          });
        });
    } else {
      cc();
    }
  }

  changeTab(index) {
    this.tabs = this.tabs.map((item) => {
      item.active = item.index === index;
      return item;
    });
    this.insertParam(index);
  }
  insertParam(value) {
    if (this.fromCanvas) return;
    const queryParams = { tab_index: +value };
    this.router.navigate([], {
      relativeTo: this.activatedRoute,
      queryParams,
      queryParamsHandling: 'merge',
    });
  }
  filterContact(facility) {
    const res = facility.entity_contacts;
    return res?.filter((e) => e.is_prime === true);
  }

  editFacility(facility: FacilityModel) {
    this.navigationService.navigateTo('lists/facilities/edit/' + facility.id);
  }
  facilityName() {
    const div = document.querySelector('.name-div') as HTMLElement;
    const text = this.facility.name ? this.facility.name : '';
    const textLength = text.length;
    const fontSize = Math.floor(220 / textLength);
    const newSize = (fontSize + 5) * 12 - 15;
    div.style.fontSize = textLength < 16 ? 20 + 'px' : newSize + '%';
    return text;
  }
  showFacilityPhoto(facility) {
    if (!this.facility.pre_signed_url?.url) {
      return;
    }
    this.dialog.open(ZoomInEntityComponent, { data: { entity: facility }, maxWidth: '600px' });
  }
}
